import React, { useState, useEffect } from "react";
import env from "../../config/env.js";
import { getHeaders } from "../../utils/apiUtils";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormControlLabel,
  Switch,
  Tooltip,
  TableSortLabel,
  TablePagination,
  Tabs,
  Tab,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { formatarDataHora, formatarData } from "../../utils/formatadores";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Close as CloseIcon,
  Print as PrintIcon,
  ThumbUp,
  ThumbDown,
  Person as PersonIcon
} from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import * as MuiIcons from "@mui/icons-material";
import axios from "axios";
import api from "../../services/api";

import AcessoRestrito from '../../components/AcessoRestrito';

// Removido drawerWidth - não utilizado neste módulo 

// Arrays estáticos de status e tipos
const STATUS_OPTIONS = [
  { value: "Ativo", label: "Ativo" },
  { value: "Inativo", label: "Inativo" }
];

const PERFIL_OPTIONS = [
  { value: "superusuario", label: "Super Usuário" },
  { value: "admin", label: "Administrador" },
  { value: "operador", label: "Operador" },
  { value: "guest", label: "Convidado" }
];

const PERFIL_HIERARCHY = {
  superusuario: ["superusuario", "admin", "operador", "guest"],
  admin: ["admin", "operador", "guest"],
  operador: ["operador", "guest"],
  guest: ["guest"]
};

const sanitizeUsuarioPayload = (dados, { includeSenha = false } = {}) => {
  const payload = {
    st_nome: dados.st_nome?.trim(),
    st_email: dados.st_email?.trim(),
    st_telefone: dados.st_telefone?.trim(),
    en_perfil: dados.en_perfil,
    id_empresa: dados.id_empresa ? Number(dados.id_empresa) : undefined,
    profile_id: dados.profile_id ? Number(dados.profile_id) : undefined,
    bo_ativo: dados.bo_ativo ? 1 : 0,
    st_codHashEmpresa: dados.st_codHashEmpresa || undefined
  };

  if (includeSenha && dados.st_senha) {
    payload.st_senha = dados.st_senha;
  }

  return Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value !== undefined && value !== null && value !== "")
  );
};

const normalizarListaApi = (res) => {
  if (Array.isArray(res.data?.dados)) return res.data.dados;
  if (Array.isArray(res.data)) return res.data;
  return [];
};

const profileEstaAtivo = (profile) => {
  return profile.ativo === undefined || profile.ativo === true || profile.ativo === 1 || profile.ativo === '1';
};

const getEmpresaIdProfile = (profile) => {
  return profile.empresa_id || profile.empresa?.id_empresa || '';
};

const getNomePerfilGestao = (usuario) => usuario?.perfil_gestao?.nome || 'Sem Perfil de Gestão';

// Estilos compartilhados para os Dialogs
const dialogPaperStyles = {
  width: { xs: '95vw', sm: '90vw', md: '900px' },
  height: { xs: '95vh', sm: '90vh', md: '550px' },
  maxWidth: { xs: '95vw', sm: '90vw', md: '900px' },
  maxHeight: { xs: '95vh', sm: '90vh', md: '550px' },
  position: 'relative',
  margin: { xs: 'auto', sm: 'auto', md: 'auto' }
};

const dialogBackdropStyles = {
  '& .MuiDialog-backdrop': {
    backgroundColor: 'rgba(0, 0, 0, 0.8)'
  }
};

const dialogTitleStyles = {
  backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
  borderBottom: 1,
  borderColor: 'divider',
  padding: 2,
  position: 'sticky',
  top: 0,
  zIndex: 1,
  fontSize: '1.25rem',
  fontWeight: 500
};

const dialogContentStyles = {
  height: 'calc(100% - 140px)',
  overflow: 'auto',
  padding: 2,
  '&.MuiDialogContent-root': {
    paddingTop: 2
  },
  position: 'relative',
  top: 0,
  marginBottom: '60px',
  '& .MuiInputLabel-root': {
    fontSize: '0.875rem'
  },
  '& .MuiInputBase-input': {
    fontSize: '0.875rem'
  },
  '& .MuiFormControlLabel-label': {
    fontSize: '0.875rem'
  }
};

const dialogActionsStyles = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  padding: 2,
  backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
  borderTop: 1,
  borderColor: 'divider',
  zIndex: 1,
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& .MuiButton-root': {
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    fontWeight: 500
  },
  '& .MuiTypography-root': {
    fontSize: '0.875rem'
  }
};

const dialogCommonProps = {
  maxWidth: false,
  fullWidth: false,
  disableEscapeKeyDown: true,
  sx: dialogBackdropStyles,
  PaperProps: {
    sx: dialogPaperStyles
  }
};

const bloquearFechamentoPorBackdrop = (fechar) => (_event, reason) => {
  if (reason === 'backdropClick') return;
  fechar();
};

// Componente compartilhado para Tabs
const TabsUsuario = ({ activeTab, handleTabChange }) => (
  <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
    <Tabs value={activeTab} onChange={handleTabChange}>
      <Tab label="Dados Básicos" />
      <Tab label="Acesso" />
    </Tabs>
  </Box>
);

// Componente compartilhado para botões de navegação
const BotoesNavegacao = ({ activeTab, handleAnterior, handleProximo, onClose, onSave, salvandoUsuario, formData }) => (
  <Box sx={{ display: 'flex', gap: 1 }}>
    <Button
      variant="contained"
      color="primary"
      onClick={handleAnterior}
      disabled={activeTab === 0}
    >
      ANTERIOR
    </Button>
    <Button
      variant="contained"
      color="primary"
      onClick={handleProximo}
      disabled={activeTab === 1}
    >
      PRÓXIMO
    </Button>
    {onClose && (
      <Button
        variant="contained"
        color="primary"
        onClick={onClose}
      >
        FECHAR
      </Button>
    )}
    {onSave && (
      <Button
        variant="contained"
        color="primary"
        onClick={onSave}
      disabled={!formData?.st_nome || !formData?.st_email || !formData?.st_telefone || !formData?.en_perfil || !formData?.id_empresa || (formData?.en_perfil !== 'superusuario' && !formData?.profile_id) || salvandoUsuario}
        startIcon={salvandoUsuario ? <CircularProgress size={16} color="inherit" /> : null}
        sx={{ ml: 1 }}
      >
        {salvandoUsuario ? "SALVANDO..." : "SALVAR"}
      </Button>
    )}
  </Box>
);



export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [salvandoUsuario, setSalvandoUsuario] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [filtros, setFiltros] = useState({
    st_nome: "",
    st_email: "",
    perfil_gestao: "",
    razao_social: "",
    st_cpf: "",
  });
  const [orderBy, setOrderBy] = useState("st_nome");
  const [order, setOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openForm, setOpenForm] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [usuarioVisualizar, setUsuarioVisualizar] = useState(null);
  const [usuarioParaExcluir, setUsuarioParaExcluir] = useState(null);
  const [moduleInfo, setModuleInfo] = useState(null);

  const location = useLocation();

  // Função para obter ícone dinamicamente
  const getMuiIconByName = (nomeIcone) => {
    if (!nomeIcone) return <PersonIcon sx={{ color: "#FFC107" }} />;

    // Mapeamento especial para ícones que não seguem o padrão
    const mapeamentoEspecial = {
      'restore': 'Restore',
      'dashboard': 'Dashboard',
      'users': 'People',
      'user': 'Person',
      'company': 'Business',
      'service': 'Build',
      'schedule': 'Schedule',
      'finance': 'AttachMoney',
      'report': 'Assessment',
      'settings': 'Settings',
      'clientes': 'Person',
      'colaboradores': 'People',
      'usuarios': 'Person'
    };

    // Verifica se há um mapeamento especial
    if (mapeamentoEspecial[nomeIcone]) {
      const nomeMapeado = mapeamentoEspecial[nomeIcone];
      if (Object.prototype.hasOwnProperty.call(MuiIcons, nomeMapeado)) {
        const IconComponent = MuiIcons[nomeMapeado];
        return <IconComponent sx={{ color: "#FFC107" }} />;
      }
    }

    // Tenta carregar diretamente
    if (Object.prototype.hasOwnProperty.call(MuiIcons, nomeIcone)) {
      const IconComponent = MuiIcons[nomeIcone];
      return <IconComponent sx={{ color: "#FFC107" }} />;
    }

    // Fallback para ícone padrão
    return <PersonIcon sx={{ color: "#FFC107" }} />;
  };

  // Carregar informações do módulo ao inicializar
  useEffect(() => {
    const carregarInfoModulo = async () => {
      try {
        // Tenta obter informações do módulo do localStorage (carregadas pelo MainLayout)
        const rotasModulos = JSON.parse(localStorage.getItem('rotasModulos') || '[]');
        const pathname = location.pathname;
        const moduleName = pathname.split('/')[1]; // Ex: "/usuarios" -> "usuarios"

        // Procura o módulo atual nas rotas carregadas
        const moduloAtual = rotasModulos.find(rota => rota.path === `/${moduleName}`);

        if (moduloAtual) {
          setModuleInfo(moduloAtual);
        } else {
          // Fallback para informações padrão do módulo
          setModuleInfo({
            nome: 'Usuários',
            icone: 'usuarios',
            path: '/usuarios'
          });
        }
      } catch (error) {
        console.warn('Erro ao carregar informações do módulo:', error);
        // Fallback para informações padrão
        setModuleInfo({
          nome: 'Usuários',
          icone: 'usuarios',
          path: '/usuarios'
        });
      }
    };

    carregarInfoModulo();
  }, [location.pathname]);

  // Obter ícone do módulo atual baseado nas informações carregadas
  const getModuleIcon = () => {
    // Se temos informações do módulo, usa o ícone específico
    if (moduleInfo && moduleInfo.icone) {
      return getMuiIconByName(moduleInfo.icone);
    }

    // Fallback baseado na rota
    const pathname = location.pathname;
    const moduleName = pathname.split('/')[1]; // Ex: "/usuarios" -> "usuarios"

    return getMuiIconByName(moduleName || 'usuarios');
  };

  const [formData, setFormData] = useState({
    st_nome: "",
    st_email: "",
    st_senha: "123Mudar",
    st_telefone: "",
    en_perfil: "operador",
    id_empresa: "",
    profile_id: "",
    bo_ativo: true
  });

  const [activeTab, setActiveTab] = useState(0);
  const [perfilLogado, setPerfilLogado] = useState("operador");
  const [st_codHashEmpresa, setStCodHashEmpresa] = useState(null);

  // Carregar dados do usuário logado
  useEffect(() => {
    try {
      const usuarioStored = localStorage.getItem("usuario");
      const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");

      if (usuarioStored) {
        const usuarioLogado = JSON.parse(usuarioStored);
        setPerfilLogado(usuarioLogado?.perfil || "operador"); // ✅ Fallback de negócio
        setStCodHashEmpresa(usuarioLogado?.st_codHashEmpresa || codHashEmpresa);
      } else {
        setPerfilLogado("operador");
        setStCodHashEmpresa(codHashEmpresa);
      }
    } catch (error) {
      console.error("❌ Erro ao carregar dados do usuário:", error);
      console.error("❌ Detalhes do erro:", {
        message: error.message,
        stack: error.stack
      });
      setPerfilLogado("operador");
      setStCodHashEmpresa(localStorage.getItem("st_codHashEmpresa"));
    }
  }, []);

  // Função para criar logs de autenticação
  // Função de log de auditoria removida - agora é feita no backend

  const carregarEmpresas = async () => {
    try {
      const headers = getHeaders();
      const res = await api.get('/empresas', { headers });

      let lista = [];
      if (res.data?.dados && Array.isArray(res.data.dados)) {
        lista = res.data.dados;
      } else if (Array.isArray(res.data)) {
        lista = res.data;
      } else if (res.data?.empresas && Array.isArray(res.data.empresas)) {
        lista = res.data.empresas;
      } else {
        lista = [];
      }

      if (perfilLogado !== PERFIL_OPTIONS[0].value) {
        lista = lista.filter(
          (empresa) =>
            empresa.st_codHashEmpresa === st_codHashEmpresa ||
            empresa.st_codHashOrigem === st_codHashEmpresa
        );
      }

      setEmpresas(lista);
    } catch (err) {
      console.error("❌ Erro ao carregar empresas:", err);
      console.error("❌ Detalhes:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        statusText: err.response?.statusText
      });
    }
  };

  const carregarProfiles = async () => {
    try {
      const headers = getHeaders();
      const res = await api.get('/profiles', { headers });
      setProfiles(normalizarListaApi(res).filter(profileEstaAtivo));
    } catch (err) {
      console.warn("Erro ao carregar perfis:", err.message || err);
      setProfiles([]);
    }
  };

  const carregarProfileUsuario = async (idUsuario) => {
    try {
      const headers = getHeaders();
      const res = await api.get(`/profiles/users/${idUsuario}`, { headers });
      const lista = Array.isArray(res.data?.dados) ? res.data.dados : [];
      const profileId = lista[0]?.profile_id || lista[0]?.profile?.id || "";
      setFormData((prev) => ({ ...prev, profile_id: profileId }));
    } catch (err) {
      console.warn("Erro ao carregar perfil do usuário:", err.message || err);
    }
  };

  const carregarUsuarios = async () => {
    setLoading(true);
    try {
      const headers = getHeaders();
      const res = await api.get('/usuarios', { headers });

      let lista = [];
      if (res.data?.dados && Array.isArray(res.data.dados)) {
        lista = res.data.dados;
      } else if (Array.isArray(res.data)) {
        lista = res.data;
      } else if (res.data?.usuarios && Array.isArray(res.data.usuarios)) {
        lista = res.data.usuarios;
      } else {
        lista = [];
      }

      // Adicionar nome da empresa
      lista = lista.map((u) => {
        const empresa = empresas.find((e) => e.id_empresa === u.id_empresa);
        return {
          ...u,
          razao_social: empresa?.st_nome || "", // ✅ Fallback de negócio
        };
      });

      // Filtrar por hierarquia de perfis
      if (perfilLogado && PERFIL_HIERARCHY[perfilLogado]) {
        const perfisPermitidos = PERFIL_HIERARCHY[perfilLogado];
        lista = lista.filter((u) => {
          const temPermissao = perfisPermitidos.includes(u.en_perfil);
          return temPermissao;
        });
      }

      // Filtrar por empresa se não for superusuário
      if (perfilLogado !== 'superusuario') {
        lista = lista.filter((u) => {
          const mesmaEmpresa = u.st_codHashEmpresa === st_codHashEmpresa;
          return mesmaEmpresa;
        });
      } else {
        // Superusuário pode ver todos os usuários
      }

      setUsuarios(lista);
    } catch (err) {
      console.error("❌ Erro ao carregar usuários:", err);
      console.error("❌ Detalhes do erro:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        statusText: err.response?.statusText,
        headers: err.response?.headers
      });
    } finally {
      setLoading(false);
    }
  };

  // Carregar empresas apenas uma vez quando o componente montar
  useEffect(() => {
    if (st_codHashEmpresa) {
      carregarEmpresas();
      carregarProfiles();
    }
  }, [st_codHashEmpresa]); // Removida dependência circular

  // Carregar usuários quando empresas estiverem disponíveis
  useEffect(() => {
    if (empresas.length > 0 && st_codHashEmpresa) {
      carregarUsuarios();
    }
  }, [empresas.length, st_codHashEmpresa]); // Usar apenas length, não o array completo

  const handleFiltroChange = (e) => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "st_telefone") {
      let raw = value.replace(/\D/g, "").slice(0, 11);
      raw = raw.replace(/^(\d{2})(\d)/, "($1) $2");
      raw = raw.replace(/(\d{5})(\d)/, "$1-$2");
      return setFormData({ ...formData, [name]: raw });
    }

    const newValue = type === "checkbox" ? checked : value;
    setFormData({
      ...formData,
      [name]: newValue,
      ...(name === "id_empresa" ? { profile_id: "" } : {})
    });
  };

  const abrirFormulario = (usuario = null) => {
    setUsuarioSelecionado(usuario);
    setSalvandoUsuario(false); // Reset do estado de salvamento
    carregarProfiles();

    // Obter st_codHashEmpresa do usuário logado
    const codHashEmpresa = localStorage.getItem("st_codHashEmpresa") || st_codHashEmpresa;
    const empresaPadrao = empresas.length === 1 ? empresas[0].id_empresa : "";

    setFormData(
      usuario
        ? {
          // ✅ CORREÇÃO: Desestruturar o usuário para evitar que objetos aninhados (como 'profile')
          // sobrescrevam os IDs esperados pelo formulário.
          ...usuario, 
          // ✅ GARANTIA: Assegurar que o 'profile_id' seja o ID numérico, não o objeto.
          profile_id: usuario.perfil_gestao?.id || usuario.profile?.id || usuario.profile_id || '',
          bo_ativo: usuario.bo_ativo === 1 || usuario.bo_ativo === true,
          st_codHashEmpresa: usuario.st_codHashEmpresa || codHashEmpresa
        }
        : {
          st_nome: "",
          st_email: "",
          st_senha: "123Mudar",
          st_telefone: "",
          en_perfil: "operador",
          id_empresa: empresaPadrao,
          profile_id: "",
          bo_ativo: true,
          st_codHashEmpresa: codHashEmpresa
        }
    );
    if (usuario?.id_usuario) {
      carregarProfileUsuario(usuario.id_usuario);
    }
    setOpenForm(true);
  };

  const visualizarUsuario = (usuario) => {
    setUsuarioVisualizar(usuario);
    setOpenView(true);
  };

  const fecharFormulario = () => {
    setOpenForm(false);
    setUsuarioSelecionado(null);
    setSalvandoUsuario(false); // Reset do estado de salvamento
  };

  const fecharVisualizacao = () => {
    setOpenView(false);
    setUsuarioVisualizar(null);
  };

  const confirmarExclusao = (usuario) => {
    setUsuarioParaExcluir(usuario);
    setOpenDeleteConfirm(true);
  };

  const fecharConfirmacaoExclusao = () => {
    setOpenDeleteConfirm(false);
    setUsuarioParaExcluir(null);
  };

  const deletarUsuario = async () => {
    if (!usuarioParaExcluir) return;

    try {
      setLoading(true);

      const headers = getHeaders();
      const idParaExcluir = usuarioParaExcluir.id_usuario || usuarioParaExcluir.id;

      if (!idParaExcluir) {
        throw new Error("ID do usuário não encontrado para exclusão.");
      }

      await api.delete(`/usuarios/${idParaExcluir}`, { headers });

      setSuccess("Usuário excluído com sucesso!");
      carregarUsuarios();
    } catch (error) {
      if (error.response?.status === 401) {
        setError("Sessão expirada. Por favor, faça login novamente.");
      } else {
        setError(error.response?.data?.message || "Erro ao excluir usuário");
      }
    } finally {
      setLoading(false);
      fecharConfirmacaoExclusao();
    }
  };

  const salvarUsuario = async () => {
    // Prevenir múltiplos cliques
    if (salvandoUsuario) {
      return;
    }

    try {
      const headers = getHeaders();

      // Garantir que o st_codHashEmpresa está sendo incluído
      const codHashEmpresa = localStorage.getItem("st_codHashEmpresa") || st_codHashEmpresa;
      const formDataComEmpresa = {
        ...formData,
        st_codHashEmpresa: codHashEmpresa
      };

      const payload = sanitizeUsuarioPayload(formDataComEmpresa, { includeSenha: !usuarioSelecionado });

      // Garantir que st_codHashEmpresa está no payload mesmo após sanitização
      if (!payload.st_codHashEmpresa && codHashEmpresa) {
        payload.st_codHashEmpresa = codHashEmpresa;
      }

      if (!usuarioSelecionado && !payload.st_senha) {
        alert("Defina uma senha para o novo usuário.");
        return;
      }

      if (payload.en_perfil !== 'superusuario' && !payload.profile_id) {
        setError("Selecione um Perfil de Gestão ativo para este usuário.");
        return;
      }

      // Ativar indicador de processamento
      setSalvandoUsuario(true);

      const resposta = usuarioSelecionado
        ? await api.put(`/usuarios/${usuarioSelecionado.id_usuario}`, payload, { headers })
        : await api.post('/usuarios', payload, { headers });

      if (resposta.data) {
        // ✅ Usar o Snackbar para feedback de sucesso, que já está implementado
        const mensagemSucesso = usuarioSelecionado ? "Usuário atualizado com sucesso!" : "Usuário salvo com sucesso!";
        setSuccess(mensagemSucesso);

        // Aguardar um pouco para o usuário ver a mensagem
        await new Promise(resolve => setTimeout(resolve, 1500));

        // Fechar formulário e recarregar lista
        fecharFormulario();
        carregarUsuarios();
      }
    } catch (error) {
      console.error("❌ Detalhes do erro:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      const mensagemErro =
        error.response?.data?.mensagem ||
        error.response?.data?.detalhes ||
        "Erro ao salvar usuário.";
      // ✅ Usar o Snackbar para feedback de erro, que já está implementado
      setError(mensagemErro);
    } finally {
      // Sempre desativar o indicador de processamento
      setSalvandoUsuario(false);
    }
  };

  const getProfilesEmpresaSelecionada = () => {
    if (!formData.id_empresa) {
      return profiles;
    }

    // ✅ CORREÇÃO: Adicionar a verificação de perfil ativo aqui também para garantir
    // que apenas perfis ativos da empresa selecionada sejam mostrados.
    return profiles.filter((profile) => profileEstaAtivo(profile) && Number(getEmpresaIdProfile(profile)) === Number(formData.id_empresa));
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const usuariosFiltrados = usuarios
    .filter((usuario) => {
      return usuario.st_nome.toLowerCase().includes(filtros.st_nome.toLowerCase()) &&
        usuario.st_email.toLowerCase().includes(filtros.st_email.toLowerCase()) &&
        getNomePerfilGestao(usuario).toLowerCase().includes(filtros.perfil_gestao.toLowerCase()) &&
        (perfilLogado !== 'superusuario' ||
          usuario.razao_social.toLowerCase().includes(filtros.razao_social.toLowerCase()));
    })
    .sort((a, b) => {
      const isAsc = order === "asc";
      if (orderBy === "st_nome" || orderBy === "st_email" || orderBy === "razao_social") {
        return isAsc
          ? a[orderBy].localeCompare(b[orderBy])
          : b[orderBy].localeCompare(a[orderBy]);
      } else if (orderBy === "perfil_gestao") {
        return isAsc
          ? getNomePerfilGestao(a).localeCompare(getNomePerfilGestao(b))
          : getNomePerfilGestao(b).localeCompare(getNomePerfilGestao(a));
      } else if (orderBy === "bo_ativo") {
        return isAsc
          ? (a.bo_ativo === b.bo_ativo ? 0 : a.bo_ativo ? -1 : 1)
          : (a.bo_ativo === b.bo_ativo ? 0 : a.bo_ativo ? 1 : -1);
      }
      return 0;
    });

  const usuariosPaginados = usuariosFiltrados.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    if (newValue === 1) {
      carregarProfiles();
    }
  };

  const handleAnterior = () => {
    setActiveTab((prevActiveTab) => prevActiveTab - 1);
  };

  const handleProximo = () => {
    setActiveTab((prevActiveTab) => prevActiveTab + 1);
  };

  const imprimirUsuario = (usuario) => {
    const novaJanela = window.open("", "_blank", "width=1000,height=800,scrollbars=yes");
    const dataHoraAtual = formatarDataHora(new Date());
    const dataAtual = formatarData(new Date());

    if (!novaJanela) {
      alert("Não foi possível abrir a nova janela.");
      return;
    }

    const style = `
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 15px;
          background-color: #ffffff;
          color: #000000;
          line-height: 1.3;
          font-size: 11px;
        }
        h1 {
          text-align: center;
          color: #1976d2;
          font-size: 18px;
          margin-bottom: 15px;
        }
        h2 {
          color: #1976d2;
          border-bottom: 1px solid #e0e0e0;
          padding-bottom: 5px;
          margin-top: 15px;
          font-size: 13px;
        }
        .header-info {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 7pt;
          color: #666;
          padding: 3px;
          background-color: white;
          border-bottom: 1px solid #eee;
        }
        .termo-section {
          margin: 10px 0;
          text-align: justify;
        }
        .termo-section p {
          margin: 8px 0;
          text-indent: 15px;
        }
        .usuario-info {
          background-color: #f5f5f5;
          padding: 10px;
          border-radius: 5px;
          margin: 10px 0;
          font-size: 10px;
        }
        .usuario-info h3 {
          color: #1976d2;
          margin-bottom: 8px;
          font-size: 12px;
        }
        .info-row {
          display: flex;
          margin: 3px 0;
          border-bottom: 1px solid #e0e0e0;
          padding-bottom: 2px;
        }
        .info-label {
          font-weight: bold;
          width: 120px;
          color: #1976d2;
        }
        .info-value {
          flex: 1;
        }
        .assinatura-section {
          margin-top: 20px;
          text-align: center;
        }
        .linha-assinatura {
          width: 250px;
          border-bottom: 1px solid #000;
          margin: 10px auto;
          height: 1px;
        }
        .botoes {
          margin-top: 15px;
          text-align: center;
        }
        button {
          background-color: #1976d2;
          color: white;
          padding: 8px 15px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          margin: 0 5px;
          font-size: 10px;
        }
        button:hover {
          background-color: #1565c0;
        }
        .artigo {
          font-weight: bold;
          color: #1976d2;
        }
        .destaque {
          font-weight: bold;
          color: #1976d2;
        }
        @media print {
          .botoes { display: none; }
          .header-info { display: none; }
        }
      </style>
    `;

    const content = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Termo de Consentimento LGPD - ${usuario.st_nome}</title>
        <meta charset="utf-8">
      </head>
      <body>
        ${style}
        <div class="header-info">
          Sistema de Gestão - Termo de Consentimento LGPD - ${dataHoraAtual}
        </div>
        
        <h1>TERMO DE CONSENTIMENTO LGPD</h1>
        
        <div class="termo-section">
          <p>Eu, <span class="destaque">${usuario.st_nome}</span>, 
          portador(a) do e-mail <span class="destaque">${usuario.st_email}</span>, 
          declaro que li e compreendi as informações sobre o tratamento dos meus dados pessoais.</p>
        </div>

        <div class="usuario-info">
          <h3>Dados do Usuário:</h3>
          <div class="info-row">
            <div class="info-label">Nome:</div>
            <div class="info-value">${usuario.st_nome || 'N/A'}</div> <!-- ✅ Fallback de negócio -->
          </div>
          <div class="info-row">
            <div class="info-label">E-mail:</div>
            <div class="info-value">${usuario.st_email || 'N/A'}</div> <!-- ✅ Fallback de negócio -->
          </div>
          <div class="info-row">
            <div class="info-label">Telefone:</div>
            <div class="info-value">${usuario.st_telefone || 'N/A'}</div> <!-- ✅ Fallback de negócio -->
          </div>
          <div class="info-row">
            <div class="info-label">Perfil de Gestão:</div>
            <div class="info-value">${getNomePerfilGestao(usuario)}</div>
          </div>
          <div class="info-row">
            <div class="info-label">Status:</div>
            <div class="info-value">${usuario.bo_ativo ? 'Ativo' : 'Inativo'}</div>
          </div>
          <div class="info-row">
            <div class="info-label">Empresa:</div>
            <div class="info-value">${usuario.razao_social || 'N/A'}</div>
          </div>
        </div>

        <div class="termo-section">
          <h2>1. Finalidade do Tratamento</h2>
          <p>Os dados pessoais serão utilizados exclusivamente para fins de autenticação, autorização, controle de acesso e gestão de usuários do sistema, conforme necessário para o funcionamento adequado da plataforma.</p>
          
          <h2>2. Base Legal</h2>
          <p>Base legal: <span class="artigo">Art. 7º, V da LGPD</span> (interesses legítimos). Dados poderão ser compartilhados com prestadores de serviços, autoridades competentes e parceiros comerciais (somente mediante consentimento).</p>
          
          <h2>3. Direitos do Titular</h2>
          <p>Conforme <span class="artigo">Art. 18 da LGPD</span>: acesso, correção, eliminação, portabilidade, revogação do consentimento e informação sobre compartilhamento.</p>
          
          <h2>4. Medidas de Segurança</h2>
          <p>Medidas de segurança conforme <span class="artigo">Art. 46 da LGPD</span>. Contato: <span class="destaque">suporte@saoinformatica.com.br</span></p>
        </div>

        <div class="assinatura-section">
          <p><strong>Data:</strong> ${dataAtual}</p>
          <p><strong>Usuário:</strong> ${usuario.st_nome}</p>
          <p><strong>E-mail:</strong> ${usuario.st_email}</p>
          <div class="linha-assinatura"></div>
          <p>Assinatura Digital</p>
        </div>

        <div class="botoes">
          <button onclick="window.print()">Imprimir</button>
          <button onclick="window.close()">Fechar</button>
        </div>
      </body>
      </html>
    `;

    novaJanela.document.write(content);
    novaJanela.document.close();
  };

  if (!st_codHashEmpresa) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <AcessoRestrito modulo="usuarios">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Snackbars para notificações */}
        <Snackbar
          open={!!error}
          autoHideDuration={env.NOTIFICATION_DURATION || 6000}
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>

        <Snackbar
          open={!!success}
          autoHideDuration={env.NOTIFICATION_DURATION || 6000}
          onClose={() => setSuccess(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setSuccess(null)} severity="success" sx={{ width: '100%' }}>
            {success}
          </Alert>
        </Snackbar>

        {/* Box interno com margens de 1,5% */}
        <Box sx={{
          margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
          height: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Header responsivo */}
          <Box sx={{
            p: { xs: 2, sm: 3 },
            pb: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}>
            <Typography
              variant="h5"
              mb={1}
              sx={{
                fontSize: { xs: '1.5rem', sm: '2rem' },
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              {React.cloneElement(getModuleIcon(), {
                sx: {
                  fontSize: { xs: '1.5rem', sm: '2rem' },
                  color: '#FFC107' // Mesma cor usada no menu lateral
                }
              })}
              Usuários
            </Typography>
            <Button
              variant="contained"
              onClick={() => abrirFormulario()}
              sx={{
                width: { xs: '100%', sm: 'auto' },
                minWidth: { xs: 'auto', sm: '200px' },
                backgroundColor: (theme) => theme.palette.mode === 'dark'
                  ? '#ffffff'
                  : theme.palette.primary.main,
                color: (theme) => theme.palette.mode === 'dark'
                  ? '#000000'
                  : theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.mode === 'dark'
                    ? '#f5f5f5'
                    : theme.palette.primary.dark,
                }
              }}
            >
              <AddIcon /> Novo Usuário
            </Button>
          </Box>

          {/* Container da Tabela */}
          <TableContainer
            component={Paper}
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              overflow: 'auto',
              height: {
                xs: 'calc(90vh - 140px)',  // Mobile: mais espaço para header
                sm: 'calc(90vh - 120px)',  // Tablet: espaço padrão
                md: 'calc(90vh - 120px)',  // Desktop: espaço padrão
                lg: 'calc(90vh - 120px)'   // Large: espaço padrão
              },
              maxHeight: {
                xs: 'calc(90vh - 140px)',
                sm: 'calc(90vh - 120px)',
                md: 'calc(90vh - 120px)',
                lg: 'calc(90vh - 120px)'
              },
              width: '100%', // ✅ 100% da largura da página
              minWidth: { xs: '100%', sm: '600px' }, // ✅ 100% do mínimo também
              maxWidth: '100%', // ✅ Limita a 100% máximo
              boxShadow: (theme) => theme.palette.mode === 'dark'
                ? '0 2px 8px rgba(0, 0, 0, 0.15)'
                : '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRadius: 2,
              border: 'none'
            }}
          >
            <Table sx={{
              minWidth: { xs: 800, sm: 650 },
              tableLayout: 'fixed',
              width: '100%'
            }}>
              <TableHead sx={{
                position: 'sticky',
                top: 0,
                zIndex: 10,
                backgroundColor: (theme) => theme.palette.background.paper,
                '& .MuiTableCell-root': {
                  backgroundColor: (theme) => theme.palette.background.paper,
                  borderBottom: 2,
                  borderBottomColor: 'divider'
                }
              }}>
                <TableRow>
                  <TableCell sx={{
                    width: { xs: '25%', sm: '20%' },
                    minWidth: { xs: '150px', sm: '120px' }
                  }}>
                    <TableSortLabel
                      active={orderBy === "st_nome"}
                      direction={orderBy === "st_nome" ? order : "asc"}
                      onClick={() => handleRequestSort("st_nome")}
                    >
                      Nome
                    </TableSortLabel>
                    <TextField
                      name="st_nome"
                      size="small"
                      fullWidth
                      value={filtros.st_nome}
                      onChange={handleFiltroChange}
                      placeholder="Filtrar por nome"
                      sx={{
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '0.75rem', sm: '0.875rem' }
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell
                    width="20%"
                    sx={{
                      height: '40px',
                      padding: '8px 16px',
                      verticalAlign: 'middle',
                      backgroundColor: 'rgba(0, 0, 0, 0.02)'
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === "st_email"}
                      direction={orderBy === "st_email" ? order : "asc"}
                      onClick={() => handleRequestSort("st_email")}
                    >
                      E-mail
                    </TableSortLabel>
                    <TextField
                      name="st_email"
                      size="small"
                      fullWidth
                      value={filtros.st_email}
                      onChange={handleFiltroChange}
                      sx={{ mt: 1 }}
                    />
                  </TableCell>
                  <TableCell
                    width="15%"
                    sx={{
                      height: '40px',
                      padding: '8px 16px',
                      verticalAlign: 'middle',
                      backgroundColor: 'rgba(0, 0, 0, 0.02)'
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === "perfil_gestao"}
                      direction={orderBy === "perfil_gestao" ? order : "asc"}
                      onClick={() => handleRequestSort("perfil_gestao")}
                    >
                      Perfil de Gestão
                    </TableSortLabel>
                    <TextField
                      name="perfil_gestao"
                      size="small"
                      fullWidth
                      value={filtros.perfil_gestao}
                      onChange={handleFiltroChange}
                      sx={{ mt: 1 }}
                    />
                  </TableCell>
                  {perfilLogado === 'superusuario' && (
                    <TableCell
                      width="20%"
                      sx={{
                        height: '40px',
                        padding: '8px 16px',
                        verticalAlign: 'middle',
                        backgroundColor: 'rgba(0, 0, 0, 0.02)'
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === "razao_social"}
                        direction={orderBy === "razao_social" ? order : "asc"}
                        onClick={() => handleRequestSort("razao_social")}
                      >
                        Empresa
                      </TableSortLabel>
                      <TextField
                        name="razao_social"
                        size="small"
                        fullWidth
                        value={filtros.razao_social}
                        onChange={handleFiltroChange}
                      />
                    </TableCell>
                  )}
                  <TableCell
                    width="10%"
                    sx={{
                      height: '40px',
                      padding: '8px 16px',
                      verticalAlign: 'middle',
                      backgroundColor: 'rgba(0, 0, 0, 0.02)',
                      textAlign: 'center'
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === "bo_ativo"}
                      direction={orderBy === "bo_ativo" ? order : "asc"}
                      onClick={() => handleRequestSort("bo_ativo")}
                    >
                      Ativo
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    width="15%"
                    sx={{
                      height: '40px',
                      padding: '8px 16px',
                      verticalAlign: 'middle',
                      backgroundColor: 'rgba: 0, 0, 0, 0.02)',
                      textAlign: 'center'
                    }}
                  >
                    Ações
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell
                      colSpan={perfilLogado === 'superusuario' ? 6 : 5}
                      align="center"
                      sx={{ py: 4 }}
                    >
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : usuariosPaginados.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={perfilLogado === 'superusuario' ? 6 : 5}
                      align="center"
                      sx={{ py: 4 }}
                    >
                      <Typography variant="body1" color="text.secondary">
                        {usuarios.length === 0
                          ? "Nenhum usuário encontrado. Clique em 'Novo Usuário' para começar."
                          : "Nenhum usuário corresponde aos filtros aplicados."
                        }
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  usuariosPaginados.map((u, index) => (
                    <TableRow
                      key={u.id_usuario}
                      sx={{
                        height: '40px', // ✅ Altura fixa de 40px para cada linha
                        backgroundColor: (theme) =>
                          index % 2 === 0
                            ? (theme.palette.mode === 'dark'
                              ? 'rgba(255, 255, 255, 0.02)'
                              : 'rgba(0, 0, 0, 0.02)')
                            : (theme.palette.mode === 'dark'
                              ? 'rgba(255, 255, 255, 0.04)'
                              : 'rgba(0, 0, 0, 0.04)'),
                        '&:hover': {
                          backgroundColor: (theme) =>
                            theme.palette.mode === 'dark'
                              ? 'rgba(255, 255, 255, 0.08)'
                              : 'rgba(0, 0, 0, 0.08)',
                          transition: 'background-color 0.2s ease'
                        }
                      }}
                    >
                      <TableCell
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          height: '40px', // ✅ Altura fixa para células
                          padding: '8px 16px', // ✅ Padding otimizado para 40px
                          verticalAlign: 'middle' // ✅ Alinhamento vertical centralizado
                        }}
                      >
                        {u.st_nome}
                      </TableCell>
                      <TableCell
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          height: '40px',
                          padding: '8px 16px',
                          verticalAlign: 'middle'
                        }}
                      >
                        {u.st_email}
                      </TableCell>
                      <TableCell
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          height: '40px',
                          padding: '8px 16px',
                          verticalAlign: 'middle'
                        }}
                      >
                        {getNomePerfilGestao(u)}
                      </TableCell>
                      {perfilLogado === 'superusuario' && (
                        <TableCell
                          sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            height: '40px',
                            padding: '8px 16px',
                            verticalAlign: 'middle'
                          }}
                        >
                          {u.razao_social}
                        </TableCell>
                      )}
                      <TableCell
                        sx={{
                          height: '40px',
                          padding: '8px 16px',
                          verticalAlign: 'middle',
                          textAlign: 'center' // ✅ Centralizar ícones
                        }}
                      >
                        {u.bo_ativo ? (
                          <Tooltip title={STATUS_OPTIONS[0].label}>
                            <ThumbUp className="material-icon-status-active" />
                          </Tooltip>
                        ) : (
                          <Tooltip title={STATUS_OPTIONS[1].label}>
                            <ThumbDown className="material-icon-status-inactive" />
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell sx={{
                        textAlign: 'right', // ✅ Alinha o conteúdo à direita
                        paddingRight: 3 // ✅ Adiciona padding à direita
                      }}>
                        <Box sx={{
                          display: 'flex',
                          gap: 1,
                          justifyContent: 'flex-end' // ✅ Alinha os botões à direita
                        }}>
                          <Tooltip title="Visualizar">
                            <IconButton size="small" onClick={() => visualizarUsuario(u)}>
                              <VisibilityIcon fontSize="small" className="material-icon-visibility" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Editar">
                            <IconButton size="small" onClick={() => abrirFormulario(u)}>
                              <EditIcon fontSize="small" className="material-icon-edit" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Imprimir Termo LGPD">
                            <IconButton size="small" onClick={() => imprimirUsuario(u)}>
                              <PrintIcon fontSize="small" className="material-icon-print" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Excluir">
                            <IconButton size="small" onClick={() => confirmarExclusao(u)}>
                              <DeleteIcon fontSize="small" className="material-icon-delete" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Paginação fora do TableContainer (igual ao Colaboradores) */}
          <TablePagination
            component="div"
            count={usuariosFiltrados.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            sx={{
              backgroundColor: (theme) => theme.palette.background.default,
              borderTop: 'none',
              width: '100%', // ✅ 100% da largura da página
              marginTop: 0
            }}
          />
        </Box> {/* Fechamento do Box interno com margens */}

        {/* Dialog de Cadastro/Edição */}
        <Dialog
          open={openForm}
          onClose={bloquearFechamentoPorBackdrop(fecharFormulario)}
          {...dialogCommonProps}
        >
          <DialogTitle sx={dialogTitleStyles}>
            {usuarioSelecionado ? "Editar Usuário" : "Novo Usuário"}
            <IconButton
              onClick={fecharFormulario}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={dialogContentStyles}>
            <TabsUsuario activeTab={activeTab} handleTabChange={handleTabChange} />

            {activeTab === 0 && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                  label="Nome"
                  name="st_nome"
                  value={formData.st_nome}
                  onChange={handleInputChange}
                  fullWidth
                  required
                />
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField
                    label="Email"
                    name="st_email"
                    type="email"
                    value={formData.st_email}
                    onChange={handleInputChange}
                    sx={{ width: '50%' }}
                    required
                  />
                  <TextField
                    label="Telefone"
                    name="st_telefone"
                    value={formData.st_telefone}
                    onChange={handleInputChange}
                    sx={{ width: '50%' }}
                    required
                  />
                </Box>
                <FormControl fullWidth>
                  <InputLabel>Empresa</InputLabel>
                  <Select
                    name="id_empresa"
                    value={formData.id_empresa}
                    onChange={handleInputChange}
                    label="Empresa"
                    required
                  >
                    {empresas.map((empresa) => (
                      <MenuItem key={empresa.id_empresa} value={empresa.id_empresa}>
                        {empresa.st_nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}

            {activeTab === 1 && (
              <Box component="form" noValidate autoComplete="off" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {!usuarioSelecionado && (
                  <TextField
                    label="Senha"
                    name="st_senha"
                    type="password"
                    value={formData.st_senha}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    helperText="Senha padrão: 123Mudar"
                  />
                )}
                <FormControl fullWidth>
                  <InputLabel>Perfil de Gestão</InputLabel>
                  <Select
                    name="profile_id"
                    value={formData.profile_id || ""}
                    onChange={handleInputChange}
                    label="Perfil de Gestão"
                  >
                    <MenuItem value="">
                      <em>Sem perfil vinculado</em>
                    </MenuItem>
                    {getProfilesEmpresaSelecionada().map((profile) => (
                      <MenuItem key={profile.id} value={profile.id}>
                        {profile.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.bo_ativo}
                      onChange={handleInputChange}
                      name="bo_ativo"
                    />
                  }
                  label={STATUS_OPTIONS[0].label}
                />
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={dialogActionsStyles}>
            <Typography variant="body2" color="text.secondary">
              {formatarDataHora(new Date())}
            </Typography>
            <BotoesNavegacao
              activeTab={activeTab}
              handleAnterior={handleAnterior}
              handleProximo={handleProximo}
              onClose={fecharFormulario}
              onSave={salvarUsuario}
              salvandoUsuario={salvandoUsuario}
              formData={formData}
            />
          </DialogActions>
        </Dialog>

        {/* VISUALIZAR */}
        <Dialog
          open={openView}
          onClose={bloquearFechamentoPorBackdrop(fecharVisualizacao)}
          {...dialogCommonProps}
        >
          <DialogTitle sx={dialogTitleStyles}>
            Visualizar Usuário
            <IconButton
              onClick={fecharVisualizacao}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={dialogContentStyles}>
            <TabsUsuario activeTab={activeTab} handleTabChange={handleTabChange} />

            {activeTab === 0 && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                  label="Nome"
                  value={usuarioVisualizar?.st_nome || ''}
                  fullWidth
                  InputProps={{
                    readOnly: true
                  }}
                  sx={{
                    '& .MuiInputBase-input': {
                      color: 'rgba(0, 0, 0, 0.6)',
                      WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                      backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    },
                    '& .MuiInputLabel-root': {
                      color: 'rgba(0, 0, 0, 0.6)'
                    }
                  }}
                />
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField
                    label="Email"
                    value={usuarioVisualizar?.st_email || ''}
                    sx={{
                      width: '50%',
                      '& .MuiInputBase-input': {
                        color: 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                    InputProps={{
                      readOnly: true
                    }}
                  />
                  <TextField
                    label="Telefone"
                    value={usuarioVisualizar?.st_telefone || ''}
                    sx={{
                      width: '50%',
                      '& .MuiInputBase-input': {
                        color: 'rgba(0, 0, 0, 0.6)',
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      },
                      '& .MuiInputLabel-root': {
                        color: 'rgba(0, 0, 0, 0.6)'
                      }
                    }}
                    InputProps={{
                      readOnly: true
                    }}
                  />
                </Box>
                <FormControl fullWidth>
                  <InputLabel sx={{
                    color: 'rgba(0, 0, 0, 0.6)'
                  }}>
                    Empresa
                  </InputLabel>
                  <Select
                    value={usuarioVisualizar?.id_empresa || ''}
                    label="Empresa"
                    readOnly
                    sx={{
                      '& .MuiSelect-select': {
                        color: 'rgba(0, 0, 0, 0.6)',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      }
                    }}
                  >
                    <MenuItem value={usuarioVisualizar?.id_empresa || ''}>
                      {usuarioVisualizar?.razao_social || ''}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}

            {activeTab === 1 && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <FormControl fullWidth>
                  <InputLabel sx={{
                    color: 'rgba(0, 0, 0, 0.6)'
                  }}>
                    Perfil de Gestão
                  </InputLabel>
                  <Select
                    value={usuarioVisualizar?.perfil_gestao?.id || ''}
                    label="Perfil de Gestão"
                    readOnly
                    sx={{
                      '& .MuiSelect-select': {
                        color: 'rgba(0, 0, 0, 0.6)',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      }
                    }}
                  >
                    <MenuItem value={usuarioVisualizar?.perfil_gestao?.id || ''}>
                      {getNomePerfilGestao(usuarioVisualizar)}
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControlLabel
                  control={
                    <Switch
                      checked={usuarioVisualizar?.bo_ativo || false}
                      disabled
                      sx={{
                        '& .MuiSwitch-switchBase.Mui-disabled': {
                          color: 'rgba(0, 0, 0, 0.3)'
                        },
                        '& .MuiSwitch-track.Mui-disabled': {
                          backgroundColor: 'rgba(0, 0, 0, 0.1)'
                        }
                      }}
                    />
                  }
                  label={STATUS_OPTIONS[0].label}
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      color: 'rgba(0, 0, 0, 0.6)'
                    }
                  }}
                />
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={dialogActionsStyles}>
            <Typography variant="body2" color="text.secondary">
              {formatarDataHora(new Date())}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAnterior}
                disabled={activeTab === 0}
              >
                ANTERIOR
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleProximo}
                disabled={activeTab === 1}
              >
                PRÓXIMO
              </Button>
              {usuarioVisualizar && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => imprimirUsuario(usuarioVisualizar)}
                >
                  IMPRIMIR
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                onClick={fecharVisualizacao}
              >
                FECHAR
              </Button>
            </Box>
          </DialogActions>
        </Dialog>

        {/* Dialog de confirmação de exclusão */}
        <Dialog
          open={openDeleteConfirm}
          onClose={fecharConfirmacaoExclusao}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: (theme) => theme.palette.background.paper
            }
          }}
        >
          <DialogTitle sx={{
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2,
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            Confirmar Exclusão
          </DialogTitle>
          <DialogContent sx={{ padding: 3 }}>
            <Typography>
              Tem certeza que deseja excluir o usuário <strong>{usuarioParaExcluir?.st_nome}</strong>?
              Esta ação não pode ser desfeita.
            </Typography>
          </DialogContent>
          <DialogActions sx={{
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderTop: 1,
            borderColor: 'divider',
            padding: 2,
            gap: 1
          }}>
            <Button
              onClick={fecharConfirmacaoExclusao}
              variant="outlined"
              sx={{
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              CANCELAR
            </Button>
            <Button
              onClick={deletarUsuario}
              variant="contained"
              color="error"
              sx={{
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              EXCLUIR
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </AcessoRestrito>
  );
}
